import React, { useEffect, useMemo } from 'react';

import { TextInput } from '@components/NextForms/TextInput';
import { getDecodeResult, MobxZodField } from '@monoid-dev/mobx-zod-form';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { formStrings } from '@utils/forms';
import { DEFAULT_PAGE_OPTIONS } from '@utils/types';
import { observer } from 'mobx-react';
import type { ZodTypeAny } from 'zod';

export const useStyles = makeMuiStyles((theme, common) => ({
  pageSizeInputContainer: {
    ...common.textGray700,
    ...common.flexInline,
    '& > label': {
      paddingTop: 6,
    },
    columnGap: 16,
  },
}));

export interface PageSizeInputProps {
  field: MobxZodField<ZodTypeAny>;
}

export const PageSizeInput: React.FC<PageSizeInputProps> = observer((props) => {
  const { field } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  useEffect(() => {
    if (field.decodeResult.success && field.form.isDirty) {
      field.form.element?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  }, [getDecodeResult(field.decodeResult)]);

  return (
    <div className={classes.pageSizeInputContainer}>
      <label>{field.type.getFormMeta().label ?? formStrings.pageSize}</label>
      <TextInput
        field={field}
        inputProps={{
          style: { width: 50 },
        }}
        inputOptions={useMemo(
          () => ({
            type: 'choose',
            options: DEFAULT_PAGE_OPTIONS.map((o) => ({
              label: String(o),
              value: o,
            })),
          }),
          [],
        )}
      />
    </div>
  );
});
